import logo from "../assets/logo.png";
import {Link} from "react-router-dom";


const XDLoadoutLogo = ({height, style, link = true}) => {
    return link ? <Link to='/'><img draggable={false} src={logo} height={height} style={style} alt='XDLoadout'/></Link> : <img draggable={false} src={logo} height={height} style={style} alt='XDLoadout'/>
}

export default XDLoadoutLogo